import { DP_SUPPORT_PHONE_NUMBER } from "redmond";

export const CONTACT_US = "Please contact us for help.";
export const CONTACT_SUPPORT_DETAILS_COPY = `It looks like you might need extra help with your request. Please give us a call at ${DP_SUPPORT_PHONE_NUMBER.boldLink} and one of our agents will be happy to assist you.`;